<template>
  <div :class="containerClass" :key="sectionInfo.title + '_commonBand'" v-if="isLoaded && isVisible" :style="getColor">
    <template v-if="isSearchView">
      <h3 class="component-title" v-band-title @click.prevent="()=>moveToTab(sectionInfo)">{{sectionInfo.title}}
        <span v-if="hasCount" class="search-customer-more-num">{{sectionInfo.count}} <NextButtonWhite /></span>
      </h3>
    </template>
    <template v-else>
      <h3 class="component-title" v-band-title>{{sectionInfo.title}}</h3>
    </template>
    <loading-band :cell-type="sectionInfo.cellType" :is-loading="loading"
                  :container-class-name="getCellListContainerClassName"></loading-band>
    <cell-list v-if="cellList && cellList.length"
               :cell-list="cellList"
               :thumbnail-info="thumbnailInfo"
               :container-class-name="getCellListContainerClassName"
               :bottom-tab="bottomTab"
               :is-bg-color="sectionInfo.bgColor"
    />
    <span v-if="hasViewMore" class="cell-list-more" @click="routeToList">
      <span>더보기</span>
      <NextButtonWhite />
    </span>
  </div>
</template>

<script>
import { getBandTypeInfoByCellType, getCellListContainerClassName } from '@/common/image.util'
import { get } from 'lodash'
import { bandTitle } from '@/common/directives'
import { parseUrl } from 'query-string'
import LoadingBand from '@/components/section/template/LoadingBand'
import EventModelClass from '@/common/model/EventModelClass'
import CellList from '@/components/section/template/cell/CellList'
import { FETCH_BAND_INFO } from '@/store/types/actions.type'
import { mapActions } from 'vuex'
import store from '@/store'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import { EventBus } from '@/components/eventbus/EventBus'
import { getTypeCodeFromTitleString } from '@/common/util/common'
import { API_BASE_AZURE_URL, API_BASE_DOMAIN, API_BASE_URL } from '@/common/constant'
import { stringify } from 'cli-highlight'

const getUiCode = (sectionInfoEvent) => {
  const url = sectionInfoEvent.url
  const { query } = parseUrl(url)
  return query.uitype
}
export default {
  name: 'CommonBand',
  components: {
    CellList,
    LoadingBand,
    NextButtonWhite
  },
  directives: { bandTitle },
  props: ['sectionInfo', 'bottomTab'],
  data () {
    return {
      isSearchView: false,
      isLoaded: false,
      isVisible: true,
      loading: true,
      genTime: '',
      cellList: [],
      thumbnailInfo: {},
      forceRefresh: false
    }
  },
  methods: {
    ...mapActions({ fetchBandData: FETCH_BAND_INFO }),
    isApiUrl (viewMoreUrl) {
      let { url } = parseUrl(viewMoreUrl)
      url = url.replace('http://', '').replace('https://', '')
      const targetUrl = url.indexOf('/') > -1 ? url.split('/')[0] : url
      const API_URL_LIST = [API_BASE_URL, API_BASE_AZURE_URL]
      return API_URL_LIST.some((baseUrl) => {
        return baseUrl.replace('https://', '').indexOf(targetUrl) > -1
      })
    },
    getUiCode (viewMoreEvent) {
      const { url, query } = parseUrl(viewMoreEvent.url)
      if (this.$route.name === 'search') {
        return url.split('/').pop()
      } else {
        return query.uitype
      }
    },
    getCustomQuery (onViewMore) {
      return {
        api: encodeURIComponent(onViewMore.url),
        referer: this.$route.fullPath,
        came: this.$route.name
      }
    },
    routeToList () {
      if (this.isApiUrl(this.sectionInfo.viewMoreEvent.url)) {
        this.$router.push({
          name: 'list',
          params: {
            section: this.$route.name,
            url: this.sectionInfo.viewMoreEvent.url,
            uiCode: this.getUiCode(this.sectionInfo.viewMoreEvent)
          },
          query: this.getCustomQuery(this.sectionInfo.viewMoreEvent)
        })
      } else {
        // TODO: 서버에 요청하여 새로운 규격 처리 해달라고 해야됨
        const { url, query } = parseUrl(this.sectionInfo.viewMoreEvent.url)
        let newUrl = url
        newUrl = newUrl.replace('https://', '')
        newUrl = newUrl.replace('http://', '')
        newUrl = newUrl.replace('m.pooq.co.kr', '')
        newUrl = newUrl.replace('www.pooq.co.kr', '')
        newUrl = newUrl.replace('www.wavve.com', '')
        newUrl = newUrl.replace('familyhub.wavve.com', '')
        newUrl = newUrl.replace('captvpooq://', '')
        newUrl = newUrl.replace('m.wavve.com', '')
        newUrl = newUrl.replace('.html', '')
        this.$router.push(newUrl + '?' + stringify(query))
      }
    },
    moveToTab (sectionInfo) {
      const type = sectionInfo.title === '에피소드' ? 'VOD' : sectionInfo.title
      EventBus.$emit('tab-type', getTypeCodeFromTitleString(type))
    },
    setData () {
      let memorize = this.hasMemorize
      if (memorize) {
        this.genTime = memorize.genTime
        this.cellType = memorize.cellType
        this.cellList = memorize.cellList
        if (this.cellList.length === 0) this.isVisible = false
        this.isLoaded = true
        this.loading = false
      }
      this.fetchBandData(
        { eventModel: new EventModelClass(this.sectionInfo.contentEvent),
          force: this.sectionInfo.forceRefresh })
        .then((response) => {
          if (this.genTime !== response.genTime || response.genTime === null) {
            this.genTime = response.genTime
            this.cellType = response.cellType
            this.cellList = response.cellList
            if (this.cellList.length === 0) this.isVisible = false
          }
          this.isLoaded = true
          this.loading = false
        })
      // this.forceRefresh = this.sectionInfo.forceRefresh
      // console.log(this.sectionInfo.cellType)
      this.thumbnailInfo = getBandTypeInfoByCellType(this.sectionInfo.cellType)
    }
  },
  computed: {
    getCellListContainerClassName () {
      let bgColor = this.sectionInfo.bgColor ? ' color' : ''
      return getCellListContainerClassName(this.thumbnailInfo.type) + bgColor
    },
    hasViewMore () {
      return get(this.sectionInfo, 'viewMoreEvent', null) !== null
    },
    hasMemorize () {
      return store.getters.hasMemorize(getUiCode(this.sectionInfo.contentEvent))
    },
    hasCount () {
      return get(this.sectionInfo, 'count', '0') !== '0'
    },
    getColor () {
      // return 'background-color:#1b1b1b'
      return 'background-color: transparent'
    },
    containerClass () {
      return 'component-container'
    }
  },
  mounted () {
    this.isSearchView = this.$route.name === 'search'
    this.setData()
  }
}
</script>
